

<div class="multiple-addresses" *ngIf="hasMultiple">
  
  <!-- button -->
  <button class="btn btn-icon-right btn-icon-right-inverted" (click)="toggleSelect()">
    <span class="text">{{ 'checkout.select-addresses' | translate }}</span>
    <i class="fa fa-angle-down"></i>
  </button>

  <!-- address select -->
  <div id="delivery-address-selector" *ngIf="hasMultiple && selectActive">
     <ul>
        <li *ngFor="let address of addresses"><a href="javascript:void(0)" (click)="onAddressClick(address)">
           <strong>{{address.name}} </strong><br/>
           {{address.addressLine1}}, {{address.city}} <br/>
           <span class="type">
              <span *ngIf="address.type === 'Delivery'">{{ 'checkout.delivery-address' | translate }}</span>
              <span *ngIf="address.type === 'Invoice'">{{ 'checkout.invoice-address' | translate }}</span>: {{ address.code }}</span>
        </a></li>
      </ul>
  </div>

</div>

<!-- the address that is selected -->
<app-address [address]="selected"></app-address>

<!--
<p style="padding-top:15px;" *ngIf="hasMultiple && !selectActive">
  <button class="btn btn-striking btn-icon-right" (click)="toggleSelect()">{{ 'checkout.select-addresses' | translate }}<i class="fa fa-angle-right"></i></button>
</p>

<select [formControl]="addressesSelect" *ngIf="hasMultiple && selectActive">
  <option *ngFor="let address of addresses" [ngValue]="address">
    {{address.name}}, {{address.addressLine1}}, {{address.city}}
  </option>
</select>
-->